import StandaloneReferenceViewerCaseLawPage from '@/standalone-reference-viewer/caselaw/views/StandaloneReferenceViewerCaseLawPage'
import StandaloneReferenceViewerLrrPage from '@/standalone-reference-viewer/lrr/views/StandaloneReferenceViewerLrrPage'
import StandaloneReferenceViewerUserFilePage from '@/standalone-reference-viewer/user-file/views/StandaloneReferenceViewerUserFilePage'
import { kRouteSegments } from '@/routing/paths'
import type { RouteFactory } from '@/routing/types'
import StandaloneAgencyDocumentPage from '@/standalone-reference-viewer/agency/StandaloneAgencyDocumentPage'
import StandaloneMatterArtifactPage from '@/standalone-reference-viewer/matter-artifact/StandaloneMatterArtifactPage'

/**
 * Creates matter-scoped standalone reference viewer routes for nesting under MatterLayout.
 * These routes display referenced content (caselaw, LRR) outside of the chat context.
 * Matter context is encoded in the URL so it is retained when opening a reference in a new tab.
 *
 * URL patterns:
 * - /dashboard/m/:matterId/reference-viewer/caselaw/:idType?/:id
 * - /dashboard/m/:matterId/reference-viewer/lrr/:s3Path
 * - /dashboard/m/:matterId/reference-viewer/user-file/:userFileId
 *
 * @see MatterLayout for parent route context
 */
export const createReferenceViewerChildRoutes: RouteFactory = () => [
  {
    path: `${kRouteSegments.referenceViewer}/artifact/:conversationId/:versionId`,
    element: <StandaloneMatterArtifactPage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/agency/:conversationId/:referenceId`,
    element: <StandaloneAgencyDocumentPage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/caselaw/:idType?/:id`,
    element: <StandaloneReferenceViewerCaseLawPage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/lrr/:s3Path`,
    element: <StandaloneReferenceViewerLrrPage />,
  },
  {
    path: `${kRouteSegments.referenceViewer}/user-file/:userFileId`,
    element: <StandaloneReferenceViewerUserFilePage />,
  },
]
